export default __webpack_public_path__ + "static/eva-45336818e112d25f1a0fa11b2f449973.jpg";